import React from "react";
import { convertMinutesToHHMM } from "../../../../../Reports/NextStopCompliance/NextStopComplianceUtills";
import { getMinutesfromTimeString } from '@dataGrid/gridUtilities';
import {
  renderTimeWithErrorIcon,
  hasStopDelayed,
  getArrivedAtOrEnrouteStop,
  getLatestBreaks,
} from "../../../utils";
import StyledToolTip from "../../../../../../common/StyledToolTip";
import { DRIVER_EVENTS } from "../../../constants";
import { getDriverStatus } from "../../../utils/DriverStatus";

export const getExpectedDelayEnd = (props, delayType) => {
  const latestBreaks = getLatestBreaks(props.data.delays);
  let latestBreak = null;
  let breakDuration = null;
  if( delayType === DRIVER_EVENTS.LunchBreak){
    latestBreak =  latestBreaks.latestLunchBreak;
    breakDuration = props.data.driverLunchDurationInMinutes;
  } else {
    latestBreak =  latestBreaks.latestRestBreak
    breakDuration = props.data.driverRestDurationInMinutes || 15;
  }
  if(latestBreak && !latestBreak?.endTime){
    const minFromTimeString = getMinutesfromTimeString(latestBreak.startTime);
    return convertMinutesToHHMM(minFromTimeString + breakDuration);
  }
  return null
}

const ETATimeRenderer = (props) => {
  if (!props.value) {
    return null;
  }
 
  const eta = props.value;
  const { driverStatus } = getDriverStatus(props, false);
  if (DRIVER_EVENTS.ReturnToTerminal === driverStatus) {
    return renderTimeWithErrorIcon(eta,false);
  } else if ([DRIVER_EVENTS.LunchBreak, DRIVER_EVENTS.RestBreak].includes(driverStatus)) {
    return eta;
  } else {
    const  selectedStop  = getArrivedAtOrEnrouteStop(props);
    if (selectedStop) {
      
      const hasDelayed = hasStopDelayed(selectedStop);
      return (
        <StyledToolTip title={hasDelayed ? 'Arriving Late' : eta}>
          {renderTimeWithErrorIcon(eta, hasDelayed)}
        </StyledToolTip>
      );
    }
  }
  return null;
};

export default ETATimeRenderer;
